var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18457_2306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.336 45.6445H7.45896C5.10067 45.6445 3.26645 43.7453 3.26645 41.3034V14.9856C3.26645 12.5438 5.10067 10.6445 7.45896 10.6445H48.336C50.6943 10.6445 52.5285 12.5438 52.5285 14.9856V41.5748C52.2665 43.7453 50.4322 45.6445 48.336 45.6445ZM7.45896 13.9003C6.9349 13.9003 6.41083 14.443 6.41083 14.9856V41.5748C6.41083 42.1174 6.9349 42.66 7.45896 42.66H48.336C48.86 42.66 49.3841 42.1174 49.3841 41.5748V14.9856C49.3841 14.443 48.86 13.9003 48.336 13.9003H7.45896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6943 18.7842H4.83865V22.04H50.6943V18.7842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6943 25.0244H4.83865V28.2802H50.6943V25.0244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.229 34.5205H10.3413V37.7763H24.229V34.5205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18457_2306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 35,
    fill: "white",
    transform: "translate(3.26645 10.6445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardActive);
export default __webpack_public_path__ + "static/media/credit-card-active.8945b6ab3f9146422fe3e9bac197c913.svg";
export { ForwardRef as ReactComponent };